<template>
  <div class="line-view">
    <chart-title-bar
      :name.sync="nameModel"
      :is-edit="isEdit">
      <template #toolbarButtons>
        <slot name="toolbarButtons" />
      </template>
    </chart-title-bar>
    <template v-if="error">
      <error-view
        :name="name"
        @reload="$emit('reload')" />
    </template>
    <template v-else>
      <slot name="moduleControls" />
      <div class="chart-container">
        <ingest-tooltip
          :left="tooltipX"
          :top="tooltipY"
          :enabled="tooltipEnabled">
          <hover-card
            :columns="columns"
            :datum="tooltipDatum"
            :beta-spec="betaSpec" />
        </ingest-tooltip>
        <resize-sensor @resize="onChartResize" />
        <svg
          ref="svg"
          :viewBox="viewBox"
          @mousemove="onHover"
          @mouseleave="onLeave()"
          @scroll="onLeave()">
          <y-axis
            :columns="columns"
            :hidden-columns="[varianceMeasure]"
            :data="data"
            :chart-width="viewWidth"
            :chart-height="viewHeight"
            @click="$emit('click', $event)" />
          <x-axis
            :columns="columns"
            :data="data"
            :chart-width="viewWidth"
            :chart-height="viewHeight"
            :highlighted-data="highlightedData" />
          <line-series
            v-if="!!secondaryMeasure"
            :measure="secondaryMeasure"
            :data="data"
            :columns="columns"
            :chart-width="viewWidth"
            :chart-height="viewHeight"
            :hidden-columns="[varianceMeasure]"
            :highlight-enabled="highlightEnabled"
            :highlighted-measures="highlightedMeasures"
            :highlighted-data="highlightedData"
            @click="$emit('click', $event)" />
          <line-series
            v-if="!!primaryMeasure"
            :measure="primaryMeasure"
            :data="data"
            :columns="columns"
            :chart-width="viewWidth"
            :chart-height="viewHeight"
            :hidden-columns="[varianceMeasure]"
            :highlight-enabled="highlightEnabled"
            :highlighted-measures="highlightedMeasures"
            :highlighted-data="highlightedData"
            @click="$emit('click', $event)" />
        </svg>
      </div>
      <measure-legend :columns="columns" />
    </template>
  </div>
</template>
<script>

  import ChartTitleBar from '@/components/charting/ChartTitleBar'
  import ErrorView from '@/components/module/view/ErrorView.vue'
  import HoverCard from '@/components/module/view/HoverCard.vue'
  import IngestTooltip from '@/components/common/IngestTooltip.vue'
  import LineSeries from '@/components/charting/LineSeries'
  import MeasureLegend from '@/components/charting/MeasureLegend'
  import XAxis from '@/components/charting/XAxis'
  import YAxis from '@/components/charting/YAxis'

  import chartContainerMixin from '@/components/charting/chart_container_mixin'

  export default {
    name: 'MeasureLineView',
    components: {
      ChartTitleBar,
      ErrorView,
      HoverCard,
      IngestTooltip,
      LineSeries,
      MeasureLegend,
      YAxis,
      XAxis,
    },
    mixins: [
      chartContainerMixin,
    ],
    methods: {
      onLeave () {
        this.clearHoverValues()
      },
    },
  }

</script>

<style lang="scss" scoped>

.line-view {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  padding: 8 * $gridBase;
  padding-top: 0;

  > .chart-container {
    display: flex;
    min-height: 0;
    flex-shrink: 1;
    flex-grow: 1;
    overflow: visible;

    margin-top: 6 * $gridBase;
    margin-bottom: 22 * $gridBase;
    margin-left: 12 * $gridBase;

    > svg {
      overflow: visible;
      width: 100%;
      height: 100%;
    }
  }
}

svg {
  overflow: visible
}

</style>
